import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    padding: '30px 25px',
    boxSizing: 'border-box',
    width: '100%',
  },
});

/**
 * ExecDetailItemDialog.jsxで使用する会社情報のコンポーネントです。
 * ExecDetailItemDialog.jsx側でchildrenに子コンポーネントを渡しています。
 * ExecDetailItemDialog.jsxからpropsで渡す引数が複雑になるので、コンポーネントを分割して、子コンポーネントだけ表示するようにしてます。
 */
class CompanyInfo extends React.Component {
  render () {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.props.children}
      </div>
    );
  }
}

CompanyInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
}

PropTypes.defaultValue = {}

export default withStyles(styles)(CompanyInfo);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/CompanyInfo.jsx